// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"c260342f","787":"12958722"}[chunkId] + ".chunk.js";
};